import React from 'react'
import { Field } from 'redux-form'

import './PhoneForm.scss'
import InputControl from 'components/InputControl'

import { createFieldValidator, required } from 'utils/validations'

const PhoneForm = () => {
  return (
    <div className='PhoneForm'>
      <Field
        component={InputControl}
        name='phone'
        type='text'
        label='Teléfono'
        validate={
          createFieldValidator([required])
        }
        />
    </div>
  )
}

PhoneForm.displayName = 'PhoneForm'

export default PhoneForm



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/screens/SecondTimeBookingConfirmation/components/PhoneForm/PhoneForm.js